export enum TransitionTypeEnum {
  FADE_IN = "fade-in",
  FADE_OUT = "fade-out",
}

export interface ICustomer {
  customerName: string;
  companyName: string;
  opinion: string;
}
